export default __webpack_public_path__ + "static/media/ods3.fe1c1939.svg";